import React from 'react';
import { STRBooking } from '../types';
import { useResponsive } from '../../hooks/useResponsive';

interface Props {
  booking: STRBooking;
  onCancel: () => void;
  onDelete: () => void;
  onClose: () => void;
}

export default function CancelModal({ booking, onCancel, onDelete, onClose }: Props) {
  const { isMobile } = useResponsive();
  const isCancelled = booking.status === 'cancelled';

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: 'white', borderRadius: 8, padding: isMobile ? 18 : 20, width: isMobile ? 'calc(100vw - 24px)' : 360, maxWidth: 360 }} onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 12px', fontSize: 16 }}>
          {isCancelled ? '예약 삭제' : '예약 취소'}
        </h3>
        <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}>
          {booking.guest_name} · {booking.check_in} ~ {booking.check_out}
        </div>
        {!isCancelled ? (
          <>
            <p style={{ fontSize: 13, margin: '12px 0' }}>이 예약을 어떻게 처리하시겠습니까?</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <button onClick={onCancel} style={{ padding: 10, background: '#fff3e0', color: '#e65100', border: '1px solid #e65100', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>
                취소 처리 (취소선으로 남김)
              </button>
              <button onClick={onDelete} style={{ padding: 10, background: '#ffebee', color: '#c62828', border: '1px solid #c62828', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>
                완전 삭제 (복구 불가)
              </button>
              <button onClick={onClose} style={{ padding: 10, background: 'white', color: '#333', border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>
                돌아가기
              </button>
            </div>
          </>
        ) : (
          <>
            <p style={{ fontSize: 13, margin: '12px 0' }}>이미 취소된 예약입니다. 완전 삭제하시겠습니까?</p>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={onDelete} style={{ flex: 1, padding: 10, background: '#c62828', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}>삭제</button>
              <button onClick={onClose} style={{ flex: 1, padding: 10, background: 'white', color: '#333', border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}>취소</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
